@if (loaded()) {
    @if (isPromo()) {
        @if (promo(); as p) {
            <asset-promo-catalogue
                [referenceId]="referenceId()"
                [promo]="p"
                (opened)="onPromoOpened($event)">
            </asset-promo-catalogue>
        }
    } @else {
        @if (tiles().length) {
            <asset-list
                [title]="details()?.title ?? null"
                [items]="tiles()"
                [displayFormat]="displayFormat()"
                size="small"
                (titleClick)="goToCatalogue()"
                (itemClick)="onItemClick($event)">
            </asset-list>
        }
    }
} @else {
    <catalogue-row-skeleton [isPromo]="isPromo()" />
}
